<template>
  <div id="camera-position-modal" class="modal camera-position-modal"  v-show="modalShown">
    <div class="modal-main">
      <div class="title-area">
        <h2>CG撮影位置設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area">
        <ul>
          <li>
            プラン前面側の選択した位置から中心に向けて撮影します。
          </li>
          <li>
            <span class="label">撮影位置</span>
            <select v-model="cameraPosition" class="form_contents">
              <option v-for="(position, index) in cameraPositionList" :key= index :value="position.code" >{{position.label}}</option>
            </select>
          </li>
        </ul>
      </div>
      <div class="button-area">
      <button type="button" class="main_btn" @click="outputCg">CG出力</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingModal from '../common/LoadingModal'

export default {
  name: 'CameraPositionModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    /** OK押下時コールバック */
    onOk: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** カメラ位置 */
      cameraPosition: 0,
      /** カメラ位置リスト */
      cameraPositionList: [
        {label: '右側：高さ1400mm', code: 0},
        {label: '右側：高さ700mm', code: 1},
        {label: '正面：高さ1400mm', code: 2},
        {label: '正面：高さ700mm', code: 3},
        {label: '左側：高さ1400mm', code: 4},
        {label: '左側：高さ700mm', code: 5}
      ]
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      // 右側高をデフォルト撮影位置とする
      this.cameraPosition = 0
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.modalShown = false
    },
    /** CG出力 */
    outputCg: function () {
      event.preventDefault()
      this.callbackParams.cameraPosition = this.cameraPosition
      this.onOk(this.callbackParams)
      this.modalShown = false
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
}
.data-area {
  padding: 20px;
  max-height: 620px;
  overflow: auto;
}
.modal-main{
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/output/DcCameraPositionModal.vue